import { Record } from 'immutable';

export default class BookingInvoiceItemAttestedDateRecord extends Record({
  id: undefined,
  date: undefined,
  price: undefined,
  resourceCost: undefined,
  resourceFee: undefined,
}) {
}
